import { setLabels } from "../helpers/enum-helpers";

export enum Division {
    Tpm = 5,
    Rlc = 10,
    ChepPlant = 15,
    Vop = 25,
    Fleet = 30,
    ReturnCenter = 50,
    Storage = 55,
	PalletSolutions = 80
}

setLabels(Division, [
    [ Division.ChepPlant, 'CHEP Plants' ],
    [ Division.Tpm, 'TPMs' ],
    [ Division.Rlc, 'RLCs' ],
    [ Division.Storage, 'Storage' ],
    [ Division.ReturnCenter, 'Return Centers' ],
    [ Division.Fleet, 'Fleet' ],
    [ Division.Vop, 'VOP' ],
    [ Division.PalletSolutions, 'Pallet Solutions' ]
]);
